export class FiltrosSolicitudes{

    TipoSolicitud : number = 0;
    NroDocumentoIdentidad = '';
    Codigo = '';
    Estado : string = 'P';
}